export default __webpack_public_path__ + "static/media/download-on-the-app-store-badge.fba0f3fa.png";